import { createContext, useState } from "react"
import { MatchesEntity, ReplacementsEntity } from "../model/languagetool/types"
import { LanguageToolOptionManager } from "../model/languagetool/optionsManager"
import { MatchesRepository } from "../model/languagetool/MatchesRepository"
import { Variants } from "../config/types"
import { CheckStatus } from "./CheckStatus"
import { getExperimentCell } from "../utils/experiments"

const getServerApi = () => {

    if (!document?.location?.href.includes('softcatala.org')) {
        return undefined
    }

    const defaultApi = "https://api.softcatala.org/corrector"

    const testCells = window.sc_corrector_settings?.experiments?.['correctorServerApi']

    if (!testCells || !Array.isArray(testCells) || testCells.length === 0) {
        return defaultApi
    }

    const experimentCell = getExperimentCell('correctorServerApi', testCells ?? [])

    if (!experimentCell) {
        return defaultApi
    }

    return testCells?.find(cell => cell.name === experimentCell)?.api ?? defaultApi
}

const server = getServerApi()

const optionManager = new LanguageToolOptionManager({ server })
const matchesRepository = new MatchesRepository()

const getMatches = async (text: string) => {
    const response = await optionManager.getLanguageToolResults(text)

    if (response?.matches) {
        matchesRepository.setSegments(response.matches)

        return response.matches
    }

    return false
}

const updateMatches = (applied: string, replacement: ReplacementsEntity) => {
    matchesRepository.update(applied, replacement.value.length)
}

type LanguageToolContextParams = {
    getMatches: (text: string) => Promise<MatchesEntity[] | false>
    updateMatches: (applied: string, replacement: ReplacementsEntity) => void
    optionManager: LanguageToolOptionManager
    matchesRepository: MatchesRepository
    variant: Variants,
    setVariant: (variants: Variants) => void
    status: CheckStatus,
    setStatus: (s: CheckStatus) => void
}

export const LanguageToolContext = createContext<LanguageToolContextParams | undefined>(undefined)

const LanguageToolProvider = ({ children }: { children: React.ReactNode }) => {
    const [variant, sv] = useState(optionManager.getVariant())
    const [status, setStatus] = useState<CheckStatus>(CheckStatus.Idle)

    const setVariant = (v: Variants) => {
        optionManager.setVariant(v)
        sv(v)
    }

    return <LanguageToolContext.Provider value={{ variant, setVariant, status, setStatus, getMatches, optionManager, updateMatches, matchesRepository }}>{children}</LanguageToolContext.Provider>
}

export { LanguageToolProvider }
